<template>
    <v-snackbar
        :timeout="timeout"
        v-model="show"
        :vertical="true"
        class="snackbar-survey"
        :location="'bottom'"
        :multi-line="true"
    >
        <template v-slot:default>
            <v-btn
                icon="$close"
                density="compact"
                @click="closeSurveyResponse"
                color="white"
                variant="text"
                class="survey-close-button"
                title="Fermer"
            ></v-btn>
            <h3 class="text-center">Votre avis compte !</h3>
            <p>
                En 2 minutes répondez à notre questionnaire et aidez-nous à améliorer votre
                expérience sur bobbee !
            </p>
        </template>
        <template v-slot:actions>
            <v-row justify="space-between">
                <v-col class="text-start">
                    <v-checkbox label="Ne plus afficher" v-model="doNotShowAgain"></v-checkbox>
                </v-col>
                <v-col class="text-end valign-middle">
                    <v-btn @click="goToSurvey" variant="flat" :slim="false" class="survey-button">
                        Je donne mon avis
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-snackbar>
</template>

<script lang="ts">
import { User } from "@/store/store";
import getEnv from "@/env";
import { Component, Vue, toNative } from "vue-facing-decorator";
// import { EnvType } from "@/types/env.types";

const env = getEnv();

/**
 * SnackbarSurvey component
 * Display a snackbar to invite the user to answer a survey
 */
@Component
export class SnackbarSurvey extends Vue {
    KEY_SURVEY = "Survey-2025-03-001";

    // -1 for no timeout
    timeout = 30000; //30000 milliseconds = 30 seconds

    show = false;

    doNotShowAgain = false;

    get localEnv() {
        return env.environnement;
    }

    /**
     * Get the current user from the store
     */
    get currentUser(): User {
        return this.$store.state.user;
    }

    /**
     * Check if the user has already responded to the survey
     * and if we not in production environment
     */
    mounted() {
        // const hasResponsedSurvey: boolean | null = JSON.parse(
        //     localStorage.getItem(this.generateKey()),
        // );

        // const isActivated = this.localEnv == "production";
        // const isActivated = this.localEnv == "staging";

        // this.show = !hasResponsedSurvey && isActivated;
        this.show = false;
    }

    /**
     * Open the survey link in a new tab
     */
    goToSurvey(): void {
        window.open(
            "https://forms.office.com/Pages/ResponsePage.aspx?id=Fgew_HxmI0iU16G1ju3aAq5LnjB61O9Po_HYY3IjkRNUMTZJN0VaV0pPRUNDVUZGMDRCNzBBRDBHWS4u",
            "_blank",
        );
        // open the link before closing the snackbar for not show the checkbox change
        this.doNotShowAgain = true;
        this.closeSurveyResponse();
    }

    /**
     * Register in local storage that the user has responded to the survey or don't want to see it anymore
     * close the snackbar
     */
    closeSurveyResponse(): void {
        if (this.doNotShowAgain) {
            localStorage.setItem(this.generateKey(), JSON.stringify(true));
        }
        this.show = false;
    }

    /**
     * Generate the key to store the survey response in local storage
     */
    generateKey(): string {
        return `${this.KEY_SURVEY}-${this.currentUser.id}`;
    }
}

export default toNative(SnackbarSurvey);
</script>

<style lang="scss">
.snackbar-survey {
    .v-snackbar__wrapper {
        padding: 24px;
    }

    .v-snackbar__content {
        h3 {
            margin-bottom: 16px;
        }

        button.survey-close-button {
            position: absolute;
            top: 3px;
            right: 3px;
        }

        padding: 0;
        padding-bottom: 16px;
    }

    .v-snackbar__actions {
        padding: 0 !important;
        margin: 0 !important;

        width: 100%;
    }

    .v-row {
        align-items: center;
        padding: 1px 0;

        .v-col {
            padding: 0 !important;
            //button.survey-button span.v-btn__content {
            //    color: black !important;
            //}
        }

        .v-col.text-end {
            padding-right: 12px !important;
            padding-bottom: 2px !important;
        }
    }
}
</style>
